var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6376 30.8822H3.41807L2.14062 18.1078H14.9151L13.6376 30.8822Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4434 18.1078V22.5788",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4434 23.8563V25.1338",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88867 23.2176V18.1078",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1074 3.41724V5.97213",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1074 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 3.41724V5.97213",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6621 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2168 3.41724V5.97213",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2168 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5527 3.41724V5.97213",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5527 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5527 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6627 19.3852V16.8303L27.6886 12.998V9.80438H25.1337V12.3593H13.6367V5.97205H25.1337V7.24949",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6369 9.16565H11.7207",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3848 19.3853H18.7461V20.6627L19.3848 21.9401V27.0499C19.3848 27.3887 19.5194 27.7136 19.759 27.9532C19.9985 28.1928 20.3235 28.3274 20.6623 28.3274C21.0011 28.3274 21.326 28.1928 21.5656 27.9532C21.8051 27.7136 21.9397 27.3887 21.9397 27.0499V21.9401L22.5784 20.6627V19.3853H19.3848Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 12.998H6.61178V9.16565H0.863281",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7793 5.33337V9.16571",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61133 9.16565H10.4437",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 5.33337H9.16667",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61133 0.862305V5.33336",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05664 0.862305V2.13975",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 12.3593V13.6367",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4961 23.2177H31.522",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0508 27.0499H31.5218",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8828 23.2177V27.05",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4961 19.3853H31.522",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0508 19.3853V23.2176",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7735 27.0499H24.4961",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 30.8823H31.522",
    stroke: "#EEEBE7",
    strokeWidth: 0.766467,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.e9d60a9c51c637bb9ad165379efb02b7.svg";
export { ForwardRef as ReactComponent };